import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import MuiTextField from '@material-ui/core/TextField';

import { withStyles } from '@material-ui/core/styles';

import { createBaseStyles } from './styles';

const styles = theme => ({
  root: {
    ...createBaseStyles(theme),
  },
});

function TextField({ className, classes, ...rest }) {
  return (
    <MuiTextField
      className={classNames(classes.root, className)}
      classes={{
        root: classes.root,
      }}
      {...rest}
    />
  );
}

TextField.defaultProps = {
  className: '',
};

TextField.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default withStyles(styles, { name: 'TextField' })(TextField);
